import styled from 'styled-components';
import breakpoint from 'Styles/breakpoints';

const getPositionValue = (enabled) => (enabled ? 'sticky' : 'static');

export const StickyBar = styled.div`
  position: ${({ enabled }) => getPositionValue(enabled.small)};

  ${breakpoint('medium')} {
    position: ${({ enabled }) => getPositionValue(enabled.medium)};
  }

  ${breakpoint('large')} {
    position: ${({ enabled }) => getPositionValue(enabled.large)};
  }

  top: ${(props) => props.topOffset};
  z-index: 550;
  width: 100%;
  background-color: var(--background);
  padding: 5px 0 5px 0;
  color: var(--foreground);
  ${({ isSticky }) =>
    isSticky && 'box-shadow: 0 0 4px 2px rgba(29, 29, 29, 0.12);'}
`;

/**
 * An invisible element that triggers active sticky styling on the FilterBar
 */
export const StickyBarIntersection = styled.div`
  background: transparent;
  height: 0px;
  position: relative;
  top: ${(props) => `-${props.topOffset}`};
`;

StickyBar.defaultProps = {
  top: '0px'
};
